module.exports = __webpack_public_path__ + "img/top_logo.b1955499.jpg";